import React from 'react'
import {StripeBG, Icon} from '../../components'
import {Navbar} from '../../components/marketing'
import {DocToc} from '../../components/blog'

class Overview extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="DocPage">
        <StripeBG bg2={"white"} style="purple"/>
        <Navbar className="grid-restrain"/>
        <section className="grid-restrain grid-row full-8">
          <DocToc />
          <div className="content markdown-doc grid-item">
            <h1 className="title">Invite your teammates</h1>
              <p>This is managed via the SnapTest website dashboard (for now). Click on the "Manage collaborators", or just point your browser to https://www.snaptest.io and click "dashboard" in the top-right. You will be able to see all your various accounts:</p>
              <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1528948261/teams/manage-collab.png" style={{"max-width": "400px"}} /></p>
              <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1528947768/teams/collab-inv.png" style={{"max-width": "300px"}} /></p>
              <p>Click to manage your team account, including inviting collaborators and setting a logo:​</p>
              <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1528948457/teams/org-collab-settings.png" style={{"max-width": "600px"}} /></p>
          </div>
        </section>
      </div>
    )
  }

}

export default Overview;



// WEBPACK FOOTER //
// ./src/pages/doc/invite.js